export default __webpack_public_path__ + "static/media/loading.08133666.gif";